import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { HealthcheckState } from '@reducers/healthcheck';

export const getHealthcheck = (state: RootState): HealthcheckState => state.healthcheck;
export const getHealthcheckData = createSelector(getHealthcheck, (healthcheck) => healthcheck?.data);
export const getHealthcheckIsLoading = createSelector(getHealthcheck, (healthcheck) => healthcheck?.loading);
